import React, { Component } from 'react';
import { Transition } from 'react-transition-group';
import anime from 'animejs';

export class ProjectTransition extends Component {
    onEnter = node => {
        // Animations are on parent and child elements
    };

    onExit = node => {
        let title = document.getElementsByClassName('OtherProjects__title')[0];
        // console.log( title );
        // Immediately hide current content
        // Visually this looks like a swap
        node.style.display = 'none';
        title.style.opacity = '0';
        // Scroll page to the top
        let tl = anime.timeline();
        tl
            .add({
                targets: 'html, body',
                scrollTop: 0,
                easing: 'easeOutExpo',
                duration: 900,
                delay: 0
            })
            .add({
                targets: title,
                opacity: [0, 1],
                easing: 'easeInSine',
                duration: 500,
                delay: 0
            });
    };

    render() {
        return (
            <Transition
                {...this.props}
                timeout={this.props.timeout}
                onEnter={this.onEnter}
                onEntered={this.onEntered}
                onExit={this.onExit}
                mountOnEnter={true}
                unmountOnExit={true}
            />
        );
    }
}

ProjectTransition.defaultProps = {
    timeout: {
        enter: 1000,
        exit: 0
    }
};

export class OtherProjectsTransition extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            animation: null
        };
    }

    onEnter = node => {};
    onExit = node => {
        node.style.display = 'none';
    };

    render() {
        return (
            <Transition
                {...this.props}
                timeout={this.props.timeout}
                onEnter={this.onEnter}
                onEntered={this.onEntered}
                onExit={this.onExit}
                mountOnEnter={true}
                unmountOnExit={true}
            />
        );
    }
}

OtherProjectsTransition.defaultProps = {
    timeout: {
        enter: 1000,
        exit: 0
    }
};



// WEBPACK FOOTER //
// ./src/components/templates/projectPage/transitions.js